import { useMutation, useQueryClient } from "react-query";
import type { UseMutationResult } from "react-query";
import type { UpdateProgramRequest } from "common/models/api/models/UpdateProgramRequest";
import { Queries } from "ui/query/queries";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { programsApi } from "../api/programsApi";

export interface UseUpdateProgramParams extends UpdateProgramRequest {
    address: string;
}

export default function useUpdateProgram({
    onSuccess,
    ...options
}: UseCustomMutationOptions<unknown, unknown, UseUpdateProgramParams> = {}): UseMutationResult<unknown, unknown, UseUpdateProgramParams> {
    const queryClient = useQueryClient();
    return useMutation(
        async ({ address, ...request }: UseUpdateProgramParams) => {
            const res = await programsApi.updateProgram(address, request);
            return res.data;
        },
        {
            ...options,
            onSuccess: (data, variables, context) => {
                queryClient.invalidateQueries([Queries.PROGRAM, variables.address]);
                queryClient.invalidateQueries(Queries.PROGRAM_FIND_ALL);
                onSuccess?.(data, variables, context);
            },
        },
    );
}
